export const BASE_BACKEND_URL = process.env.VUE_APP_BASE_URL;
export const GRAPHQL_PATH = '/graphql';
export const GRAPHQL_PUBLIC_PATH = '/graphql/public';